<template>
    <div>
        <el-card  shadow="never" class="sreceipt" >
            <div id="printMe"  class="bank-receipt" ref="contentToCapture"  >
                <div class="receipt-header"  >
                    <img src="/images/logo/nylogo.jpg" alt="" class="vylogo">
                    <div class="receipt-title">
                        <div class="main-title">网上银行电子回单</div>
                        <div class="sub-title">客户收付款入账通知</div>
                    </div>
                </div> 
                <div class="receipt-info">
                    <div>回单编号：{{ receiptInfo.receipt_no }}</div>
                </div>
                <div class="receipt">
                    <div class="main-name">
                        <div class="main-detail">
                            <div class="main-nlie">付款方</div>
                            <div class="main-nltext">
                                <div><p>账户</p></div>
                                <div><p>户名</p></div>
                                <div><p>开户行</p></div>
                            </div>
                        </div>
                        <ul class="detail-list">
                            <li>杭州自由行旅行社有限公司</li>
                            <li>19020201040025900</li>
                            <li>中国农业银行股份有限公司杭州留下支行</li>
                        </ul>
                    </div>
                    <div class="main-name">
                        <div class="main-detail">
                            <div class="main-nlie">收款方</div>
                            <div class="main-nltext">
                                <div><p>账户</p></div>
                                <div><p>户名</p></div>
                                <div><p>开户行</p></div>
                            </div>
                        </div>
                        <ul class="detail-list">
                            <li>{{ receiptInfo.truename }}</li>
                            <li>{{ receiptInfo.bank_card }}</li>
                            <li>{{ receiptInfo.branch }}{{receiptInfo.bank_name}}</li>
                        </ul>
                    </div>
                    <div class="main-name">
                        <div class="dixele">金额(小写)</div>
                        <div class="lieqs">{{ receiptInfo.payment_pay/100| formatMoney }}</div>
                    </div>
                    <div class="main-name">
                        <div class="dixele">金额(大写)</div>
                        <div class="lieqs">{{ receiptInfo.payment_pay/100| numberToChinese }}</div>
                    </div>
                    <div class="main-name">
                        <div class="dixele">币种</div>
                        <div class="lieqs">人民币</div>
                    </div>
                    <div class="main-name">
                        <div class="dixele">交易渠道</div>
                        <div class="lieqs">网上银行</div>
                    </div>
                    <div class="main-name">
                        <div class="dixele">摘要</div>
                        <div class="lieqs">费用外收</div>
                    </div>
                    <div class="main-name">
                        <div class="dixele">企业自制凭证号</div>
                        <div class="lieqs">{{ receiptInfo.pay_id }}</div>
                    </div>
                    <div class="main-name">
                        <div class="dixele">交易时间</div>
                        <div class="lieqs">{{ receiptInfo.add_time | formatTimestamp(1)}}</div>
                    </div>
                    <div class="main-name">
                        <div class="dixele">会计日期</div>  
                        <div class="lieqs">{{ receiptInfo.add_time | formatTimestamp()}}</div>
                    </div>
                    <div class="ain-nam">
                        <div class="dixele w-23">备注</div>  
                        <div class="lieqs w-24">{{ receiptInfo.remark}}</div>
                    </div>
                </div>
                <div class="gz">
                    <img src="/images/logo/gz.png">
                </div>
            </div>
        </el-card>
        <div class="sub-tit">回单编号由银行生成，凭证号由平台生成。</div>
        <div class="il-btn">
            <el-button type="primary" @click="captureAndDownload"><i class="el-icon-download"></i>下载图片</el-button>
        </div>
  </div>
</template> 

<script>
import print from 'print-js'
import html2canvas from 'html2canvas';
export default {
  name: 'BankReceipt',
  data() {
    return {
    }
    },
    props:{
        receiptInfo:{}
    },
    methods:{
        async captureAndDownload() {
            const element = this.$refs.contentToCapture; // 获取DOM元素
            const canvas = await html2canvas(element); // 将DOM转换为canvas
            const image = canvas.toDataURL('image/png'); // 将canvas转换为base64 URL
            const link = document.createElement('a'); // 创建一个a标签用于下载图片
            link.href = image;
            link.download = '打款回单.png'; // 设置下载文件名
            link.click(); // 触发点击事件，开始下载
        },
    }
}
</script>

<style scoped>
.gz{
    position: absolute;
    top: 60%;
    right: 40%;
    width: 240px;
    
}
.gz img{
    width: 100%;
    
}
.bank-receipt {
  width: 1200px;
  margin: 0 auto;
  border-radius: 0;
      padding: 20px;
}
.sreceipt{
    width: 1280px;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
}
.vylogo{
    width: 170px;
    float: left;
    position: absolute;
    top: 0;
    left: 0;
}
.receipt-header{
    position: relative;
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    overflow: hidden;
}
.main-title{
    font-weight: bold;
    font-size: 20px;
}
.sub-title{
    margin-top: 6px;
    font-size: 14px;
    display: block;
}
.receipt-info{
    width: 96%;
    padding: 12px 2%;
    border: 1px #3e3e3e solid;
    border-bottom: none;
    display: flex;
    margin-top: 16px;
}
.receipt{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
        border-right: 1px #3e3e3e solid;
}
.main-name{
    width: 50%;
        border-bottom: 1px #3e3e3e solid;
        display: flex;   
}
.main-detail{
    width: 40%;
    float: left;
    overflow: hidden;
    height: 160px;
    display: flex;

}
.main-nlie{
    width: 50%;
    text-align: center;
    background-color: #eaeaea;
    height: 100%;
    line-height: 160px;
    border-left: 1px #3e3e3e solid;
    border-top: 1px #3e3e3e solid;
}
.main-nltext{
    width: 50%;
    text-align: left;
    background-color: #eaeaea;
    border-left: 1px #3e3e3e solid;
    border-top: 1px #3e3e3e solid;

}
.main-nltext>div{
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 33%;
    border-bottom: 1px #3e3e3e solid;
}
.main-nltext>div:last-child{
    border-bottom: none;
}
.main-nltext>div p{
    width: 90%;
    margin: 0 auto;
}
.detail-list{
     border-left: 1px #3e3e3e solid;
     border-top: 1px #3e3e3e solid;
     float: left;
     width: 60%;
     height: 100%;
     display: flex;
     flex-direction: column;
}
.detail-list li{
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 33%;
    border-bottom: 1px #3e3e3e solid;
}
.dixele{
    width: 40%;
    line-height: 40px;
    border-left: 1px #3e3e3e solid;
}
.lieqs{
    width: 60%;
        line-height: 40px;
    border-left: 1px #3e3e3e solid;
}
.ain-nam{
        width: 100%;
    border-bottom: 1px #3e3e3e solid;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.w-23{
    width: 20%;
}
.w-24{
    width: 80.1%;
}
.sub-tit{
    width: 1200px;
    text-align: left;
    margin: 20px  auto;
}
.il-btn{
    width: 1240px;
    text-align: right;
    margin: 0 auto;
}
</style>  